import { render, staticRenderFns } from "./RecordDetailList.vue?vue&type=template&id=0c776538&scoped=true&"
import script from "./RecordDetailList.vue?vue&type=script&lang=js&"
export * from "./RecordDetailList.vue?vue&type=script&lang=js&"
import style0 from "./RecordDetailList.vue?vue&type=style&index=0&id=0c776538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c776538",
  null
  
)

export default component.exports